import { action } from 'typesafe-actions'
import { CartActionTypes } from './types'

// Get Discount
export const getDiscountRequest = (data: any) => action(CartActionTypes.GETDISCOUNT_REQUEST, data)
export const getDiscountSuccess = (data: any) => action(CartActionTypes.GETDISCOUNT_SUCCESS, data)  // Return deleted organiser id to remove from state
export const getDiscountError = (errors: any) => action(CartActionTypes.GETDISCOUNT_ERROR, errors)
